import { init } from "@rematch/core";
import user from "./user";
import soft from "./soft"
import config from "./config"
import softForm from "./softForm"
import oss from "./oss"
import permission from "./permission";
const store = init({ models: {
  user,
  soft,
  config,
  softForm,
  oss,
  permission,
} });
export default store;
